import { constants } from '../config/constants';

const priceToNumber = (price, regionCode) => {
  const splitPrice = price.split(constants.DECIMAL_SEPARATOR[regionCode]);
  const integerPart = splitPrice[0].replace(/[,.]/g, '');
  const number = splitPrice[1] ? `${integerPart}.${splitPrice[1]}` : integerPart;
  return Number(number);
};

const meatStickersInfo = (product) => {
  const { meatStickers = [], multipurposeBadges = [], installmentsWithoutInterest = [] } = product;

  const result = [...meatStickers.map(({ label }) => label), ...multipurposeBadges.map(({ label }) => label)];

  if (installmentsWithoutInterest.length > 0) {
    const uniqueInstallments = [
      ...new Set(installmentsWithoutInterest.map(({ installments }) => Number(installments))),
    ];
    const maxInstallments = Math.max(...uniqueInstallments);
    result.push(`${maxInstallments} ${constants.INSTALLMENT_WITHOUT_INTEREST_TEXT}`);
  }

  return result;
};

const addProductListEvent = (products, page, domain, regionCode) => {
  const items = products.map((product, index) => {
    const discountType = product.discountBadge && product.discountBadge.label;
    const price = product.prices.map((objPrice) => {
      const priceNumber = objPrice.price && objPrice.price[0] && priceToNumber(objPrice.price[0], regionCode);
      return priceNumber;
    });
    const variantsIds = product.variants.map((variant) => variant.options.map((data) => data.variant));
    const meatstickersArray = meatStickersInfo(product);
    const meatstickers = meatstickersArray && meatstickersArray.toString();

    return {
      brand: product.brand,
      category_id_subclase: product.merchantCategoryId,
      discount_type: discountType,
      id: product.productId,
      is_sponsored: product.isSponsored ? 'patrocinado' : 'no patrocinado',
      list: page.toLowerCase(),
      sellerId: product.sellerId,
      sellerName: product.sellerName,
      name: product.displayName,
      position: index + 1,
      price: Math.min(...price),
      sku_id: product.skuId,
      store_in_store: domain || 'falabella',
      sku_id_variant: variantsIds.flat(),
      gsc_catgory_id: product.GSCCategoryId,
      meatstickers,
    };
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'xlpProductList',
    productsData: items,
  });
};
const addXlpImpressionsListEvent = ({ product, page, domain, regionCode, index }) => {
  const discountType = product.discountBadge && product.discountBadge.label;
  const price = product.prices.map((objPrice) => {
    const priceNumber = objPrice.price && objPrice.price[0] && priceToNumber(objPrice.price[0], regionCode);
    return priceNumber;
  });
  const variantsIds = product.variants.map((variant) => variant.options.map((data) => data.variant));
  const meatstickersArray = meatStickersInfo(product);
  const meatstickers = meatstickersArray && meatstickersArray.toString();

  const formattedProduct = {
    brand: product.brand,
    category_id_subclase: product.merchantCategoryId,
    discount_type: discountType,
    id: product.productId,
    is_sponsored: product.isSponsored ? 'patrocinado' : 'no patrocinado',
    list: page.toLowerCase(),
    sellerId: product.sellerId,
    sellerName: product.sellerName,
    name: product.displayName,
    position: index + 1,
    price: Math.min(...price),
    sku_id: product.skuId,
    store_in_store: domain || 'falabella',
    sku_id_variant: variantsIds.flat(),
    gsc_catgory_id: product.GSCCategoryId,
    meatstickers,
  };

  window.dataLayer = window.dataLayer || [];
  let productsData = [];
  const xlpImpressionsListIndex = window.dataLayer.findIndex((item) => item.event === 'xlpImpressionsList');
  if (
    typeof xlpImpressionsListIndex === 'number' &&
    xlpImpressionsListIndex !== -1 &&
    window.dataLayer?.[xlpImpressionsListIndex]?.productsData
  ) {
    productsData = [...window.dataLayer[xlpImpressionsListIndex].productsData];
    productsData.push(formattedProduct);
    window.dataLayer[xlpImpressionsListIndex].productsData = productsData.sort((a, b) => a.position - b.position);
  } else {
    window.dataLayer.push({
      event: 'xlpImpressionsList',
      productsData: [formattedProduct],
    });
  }
};
export { addProductListEvent, addXlpImpressionsListEvent };
